module.exports = __webpack_public_path__ + "static/img/Asics-logo.3a7463aa.jpg";